import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "alp-form" }
const _hoisted_2 = {
  key: 0,
  class: "subTit"
}
const _hoisted_3 = { class: "setInput" }
const _hoisted_4 = { style: {"padding":"0 4px"} }
const _hoisted_5 = {
  key: 12,
  class: "suffix"
}
const _hoisted_6 = { class: "setInput" }
const _hoisted_7 = { style: {"padding":"0 4px"} }
const _hoisted_8 = {
  key: 13,
  class: "suffix"
}

export function render(_ctx: any,_cache: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_week_picker = _resolveComponent("a-week-picker")!
  const _component_a_time_picker = _resolveComponent("a-time-picker")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_alpMultiText = _resolveComponent("alpMultiText")!
  const _component_alpIcon = _resolveComponent("alpIcon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.titleShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.formTitle), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_config_provider, { locale: _ctx.zhCN }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({
          ref: "formRef",
          layout: _ctx.formConfg.layout,
          model: _ctx.formData,
          rules: _ctx.formRules
        }, _ctx.formConfg.a_attr, _toHandlers(_ctx.formConfg.a_event), {
          colon: _ctx.formConfg.colon,
          labelAlign: _ctx.formConfg.labelAlign,
          hideRequiredMark: _ctx.formConfg.hideRequiredMark
        }), {
          default: _withCtx(() => [
            (_ctx.formConfg.layout == 'inline')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.form, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.name + item.updatekey
                  }, [
                    (item.type == 'custom')
                      ? _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: { display: 'inline-block' },
                          class: _normalizeClass(item.class)
                        }, [
                          _renderSlot(_ctx.$slots, item.soltName)
                        ], 2)), [
                          [_vShow, !item.hidden]
                        ])
                      : _withDirectives((_openBlock(), _createBlock(_component_a_form_item, {
                          key: 1,
                          class: _normalizeClass([item.class, "formGroupItem"]),
                          label: item.label,
                          name: item.name
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              (item.type == 'input')
                                ? (_openBlock(), _createBlock(_component_a_input, _mergeProps({
                                    key: 0,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'number')
                                ? (_openBlock(), _createBlock(_component_a_input_number, _mergeProps({
                                    key: 1,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'select')
                                ? (_openBlock(), _createBlock(_component_a_select, _mergeProps({
                                    key: 2,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder,
                                    options: item.options
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "options", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'dateTime')
                                ? (_openBlock(), _createBlock(_component_a_date_picker, _mergeProps({
                                    key: 3,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    "show-time": 
                        item.hasOwnProperty('showTime')
                          ? item.showTime
                          : /h/gi.test(item.format)
                          ? true
                          : false
                      ,
                                    disabled: item.disabled,
                                    placeholder: item.placeholder,
                                    format: item.format,
                                    valueFormat: item.format
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "show-time", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'rangeTime')
                                ? (_openBlock(), _createBlock(_component_a_range_picker, _mergeProps({
                                    key: 4,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    "show-time": 
                        item.hasOwnProperty('showTime')
                          ? item.showTime
                          : /h/gi.test(item.format)
                          ? true
                          : false
                      ,
                                    disabled: item.disabled,
                                    placeholder: item.placeholder,
                                    format: item.format,
                                    valueFormat: item.format
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "show-time", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'datePicker')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _createVNode(_component_a_date_picker, _mergeProps({
                                      value: _ctx.formData[item.startName],
                                      "onUpdate:value": ($event: any) => ((_ctx.formData[item.startName]) = $event),
                                      "show-time": 
                        item.hasOwnProperty('showTime')
                          ? item.showTime
                          : /h/gi.test(item.format)
                          ? true
                          : false
                      ,
                                      format: item.format,
                                      disabled: item.disabled,
                                      "disabled-date": item.startFun,
                                      valueFormat: item.format,
                                      placeholder: item.startPlaceholder || '请选择开始'
                                    }, item.a_attr, _toHandlers(item.a_event), {
                                      key: item.updatekey
                                    }), null, 16, ["value", "onUpdate:value", "show-time", "format", "disabled", "disabled-date", "valueFormat", "placeholder"]),
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(item.spacer || "到"), 1),
                                    _createVNode(_component_a_date_picker, _mergeProps({
                                      value: _ctx.formData[item.endName],
                                      "onUpdate:value": ($event: any) => ((_ctx.formData[item.endName]) = $event),
                                      "show-time": 
                        item.hasOwnProperty('showTime')
                          ? item.showTime
                          : /h/gi.test(item.format)
                          ? true
                          : false
                      ,
                                      format: item.format,
                                      valueFormat: item.format,
                                      "disabled-date": item.endFun,
                                      placeholder: item.endPlaceholder || '请选择结束'
                                    }, item.a_attr, _toHandlers(item.a_event), {
                                      key: item.updatekey
                                    }), null, 16, ["value", "onUpdate:value", "show-time", "format", "valueFormat", "disabled-date", "placeholder"])
                                  ], 64))
                                : _createCommentVNode("", true),
                              (item.type == 'dateMonth')
                                ? (_openBlock(), _createBlock(_component_a_month_picker, _mergeProps({
                                    key: 6,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder,
                                    format: item.format,
                                    valueFormat: item.format
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'dateWeek')
                                ? (_openBlock(), _createBlock(_component_a_week_picker, _mergeProps({
                                    key: 7,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder,
                                    format: item.format,
                                    valueFormat: item.format
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'time')
                                ? (_openBlock(), _createBlock(_component_a_time_picker, _mergeProps({
                                    key: 8,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder,
                                    format: item.format,
                                    valueFormat: item.format
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'radioGroup')
                                ? (_openBlock(), _createBlock(_component_a_radio_group, _mergeProps({
                                    key: 9,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                                        return (_openBlock(), _createBlock(_component_a_radio, {
                                          key: opt.value,
                                          value: opt.value,
                                          disabled: opt.disabled
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(opt.label), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "disabled"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1040, ["value", "onUpdate:value", "disabled", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'checkboxGroup')
                                ? (_openBlock(), _createBlock(_component_a_checkbox_group, _mergeProps({
                                    key: 10,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                                        return (_openBlock(), _createBlock(_component_a_checkbox, {
                                          key: opt.value,
                                          value: opt.value,
                                          disabled: opt.disabled
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(opt.label), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "disabled"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1040, ["value", "onUpdate:value", "disabled", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.type == 'multiText')
                                ? (_openBlock(), _createBlock(_component_alpMultiText, _mergeProps({
                                    key: 11,
                                    value: _ctx.formData[item.name],
                                    "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                    disabled: item.disabled,
                                    placeholder: item.placeholder
                                  }, item.a_attr, _toHandlers(item.a_event), {
                                    key: item.updatekey,
                                    onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                  }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"]))
                                : _createCommentVNode("", true),
                              (item.suffix)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_a_button, {
                                      type: item.suffix.type,
                                      onClick: ($event: any) => (_ctx.suffixClick(_ctx.formData[item.name], item))
                                    }, {
                                      default: _withCtx(() => [
                                        (item.suffix.icon)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (!/^alpIcon/gi.test(item.suffix.icon))
                                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicIcon(item.suffix.icon)), {
                                                    key: 0,
                                                    style: _normalizeStyle({ fontSize: item.suffix.size + 'px' })
                                                  }, null, 8, ["style"]))
                                                : (_openBlock(), _createBlock(_component_alpIcon, {
                                                    key: 1,
                                                    size: item.suffix.size,
                                                    icon: _ctx.dynamicAlpIcon(item.suffix.icon)
                                                  }, null, 8, ["size", "icon"]))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(item.suffix.text), 1)
                                            ], 64))
                                      ]),
                                      _: 2
                                    }, 1032, ["type", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class", "label", "name"])), [
                          [_vShow, !item.hidden]
                        ])
                  ], 64))
                }), 128))
              : (_openBlock(), _createBlock(_component_a_row, {
                  key: 1,
                  gutter: _ctx.formConfg.gutter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form, (item) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_a_col, {
                        span: item.span,
                        offset: item.offset,
                        key: (item.name || item.soltName) + item.updatekey,
                        style: _normalizeStyle({ height: item.colHeight + 'px' }),
                        class: _normalizeClass(item.class)
                      }, {
                        default: _withCtx(() => [
                          (item.type == 'custom')
                            ? _renderSlot(_ctx.$slots, item.soltName, {
                                key: item.soltName
                              })
                            : (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 1,
                                label: item.label,
                                class: "formGroupItem",
                                name: item.name
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    (item.type == 'input')
                                      ? (_openBlock(), _createBlock(_component_a_input, _mergeProps({
                                          key: 0,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'number')
                                      ? (_openBlock(), _createBlock(_component_a_input_number, _mergeProps({
                                          key: 1,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'textarea')
                                      ? (_openBlock(), _createBlock(_component_a_textarea, _mergeProps({
                                          key: 2,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'select')
                                      ? (_openBlock(), _createBlock(_component_a_select, _mergeProps({
                                          key: 3,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          options: item.options
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "options", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'dateTime')
                                      ? (_openBlock(), _createBlock(_component_a_date_picker, _mergeProps({
                                          key: 4,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          "show-time": 
                          item.hasOwnProperty('showTime')
                            ? item.showTime
                            : /h/gi.test(item.format)
                            ? true
                            : false
                        ,
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          format: item.format,
                                          valueFormat: item.format
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "show-time", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'rangeTime')
                                      ? (_openBlock(), _createBlock(_component_a_range_picker, _mergeProps({
                                          key: 5,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          "show-time": 
                          item.hasOwnProperty('showTime')
                            ? item.showTime
                            : /h/gi.test(item.format)
                            ? true
                            : false
                        ,
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          format: item.format,
                                          valueFormat: item.format
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "show-time", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'datePicker')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                          _createVNode(_component_a_date_picker, _mergeProps({
                                            value: _ctx.formData[item.startName],
                                            "onUpdate:value": ($event: any) => ((_ctx.formData[item.startName]) = $event),
                                            "show-time": 
                          item.hasOwnProperty('showTime')
                            ? item.showTime
                            : /h/gi.test(item.format)
                            ? true
                            : false
                        ,
                                            format: item.format,
                                            disabled: item.disabled,
                                            "disabled-date": item.startFun,
                                            valueFormat: item.format,
                                            placeholder: item.startPlaceholder || '请选择开始'
                                          }, item.a_attr, _toHandlers(item.a_event), {
                                            key: item.updatekey
                                          }), null, 16, ["value", "onUpdate:value", "show-time", "format", "disabled", "disabled-date", "valueFormat", "placeholder"]),
                                          _createElementVNode("span", _hoisted_7, _toDisplayString(item.spacer || "到"), 1),
                                          _createVNode(_component_a_date_picker, _mergeProps({
                                            value: _ctx.formData[item.endName],
                                            "onUpdate:value": ($event: any) => ((_ctx.formData[item.endName]) = $event),
                                            "show-time": 
                          item.hasOwnProperty('showTime')
                            ? item.showTime
                            : /h/gi.test(item.format)
                            ? true
                            : false
                        ,
                                            format: item.format,
                                            valueFormat: item.format,
                                            "disabled-date": item.endFun,
                                            placeholder: item.endPlaceholder || '请选择结束'
                                          }, item.a_attr, _toHandlers(item.a_event), {
                                            key: item.updatekey
                                          }), null, 16, ["value", "onUpdate:value", "show-time", "format", "valueFormat", "disabled-date", "placeholder"])
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (item.type == 'dateMonth')
                                      ? (_openBlock(), _createBlock(_component_a_month_picker, _mergeProps({
                                          key: 7,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          format: item.format,
                                          valueFormat: item.format
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'dateWeek')
                                      ? (_openBlock(), _createBlock(_component_a_week_picker, _mergeProps({
                                          key: 8,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          format: item.format,
                                          valueFormat: item.format
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'time')
                                      ? (_openBlock(), _createBlock(_component_a_time_picker, _mergeProps({
                                          key: 9,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          format: item.format,
                                          valueFormat: item.format
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "format", "valueFormat", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'radioGroup')
                                      ? (_openBlock(), _createBlock(_component_a_radio_group, _mergeProps({
                                          key: 10,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                                              return (_openBlock(), _createBlock(_component_a_radio, {
                                                key: opt.value,
                                                value: opt.value,
                                                disabled: opt.disabled
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(opt.label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value", "disabled"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1040, ["value", "onUpdate:value", "disabled", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'checkboxGroup')
                                      ? (_openBlock(), _createBlock(_component_a_checkbox_group, _mergeProps({
                                          key: 11,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          onChange: ($event: any) => (_ctx.formItemChange(_ctx.formData[item.name], item))
                                        }), {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (opt) => {
                                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                                key: opt.value,
                                                value: opt.value,
                                                disabled: opt.disabled
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(opt.label), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value", "disabled"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1040, ["value", "onUpdate:value", "disabled", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.type == 'multiText')
                                      ? (_openBlock(), _createBlock(_component_alpMultiText, _mergeProps({
                                          key: 12,
                                          value: _ctx.formData[item.name],
                                          "onUpdate:value": ($event: any) => ((_ctx.formData[item.name]) = $event),
                                          disabled: item.disabled,
                                          placeholder: item.placeholder,
                                          maxLimit: item.maxLimit
                                        }, item.a_attr, _toHandlers(item.a_event), {
                                          key: item.updatekey,
                                          onChange: 
                          (data) => _ctx.formItemChange(_ctx.formData[item.name], item)
                        
                                        }), null, 16, ["value", "onUpdate:value", "disabled", "placeholder", "maxLimit", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (item.suffix)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                          _createVNode(_component_a_button, {
                                            type: item.suffix.type,
                                            onClick: ($event: any) => (_ctx.suffixClick(_ctx.formData[item.name], item))
                                          }, {
                                            default: _withCtx(() => [
                                              (item.suffix.icon)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (!/^alpIcon/gi.test(item.suffix.icon))
                                                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicIcon(item.suffix.icon)), {
                                                          key: 0,
                                                          style: _normalizeStyle({ fontSize: item.suffix.size + 'px' })
                                                        }, null, 8, ["style"]))
                                                      : (_openBlock(), _createBlock(_component_alpIcon, {
                                                          key: 1,
                                                          size: item.suffix.size,
                                                          icon: _ctx.dynamicAlpIcon(item.suffix.icon)
                                                        }, null, 8, ["size", "icon"]))
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(_toDisplayString(item.suffix.text), 1)
                                                  ], 64))
                                            ]),
                                            _: 2
                                          }, 1032, ["type", "onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "name"]))
                        ]),
                        _: 2
                      }, 1032, ["span", "offset", "style", "class"])), [
                        [_vShow, !item.hidden]
                      ])
                    }), 128))
                  ]),
                  _: 3
                }, 8, ["gutter"]))
          ]),
          _: 3
        }, 16, ["layout", "model", "rules", "colon", "labelAlign", "hideRequiredMark"])
      ]),
      _: 3
    }, 8, ["locale"])
  ]))
}